import { PublicLayout } from "@/components/public/PublicLayout";
import AssistantWidget from "@/components/public/AssistantWidget";
import { Hero } from "@/components/public/home/Hero";
import { AgentsShowcase } from "@/components/public/home/Agents";
import { WorkflowTimeline } from "@/components/public/home/Workflow";
import { ValueCalculator } from "@/components/public/home/ValueCalculator";
import { TrustSection } from "@/components/public/home/Trust";
import { Segments, EnterpriseGrid, BeforeAfter, Testimonials, DemoVideo, FinalCta } from "@/components/public/home/Sections";

export default function LandingPage() {
  return (
    <PublicLayout>
      <Hero />
      <AgentsShowcase />
      <WorkflowTimeline />
      <Segments />
      <EnterpriseGrid />
      <BeforeAfter />
      <TrustSection />
      <Testimonials />
      <ValueCalculator />
      <DemoVideo />
      <FinalCta />
      <AssistantWidget />
    </PublicLayout>
  );
}
